import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=2a3e987c"
import script from "./ProductAdd.vue?vue&type=script&lang=js"
export * from "./ProductAdd.vue?vue&type=script&lang=js"
import style0 from "./ProductAdd.vue?vue&type=style&index=0&id=2a3e987c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports